import type { RelationshipTargetKind } from '@cli-types/core-engine/add-field.js'
import { isUserRelationshipTarget } from '@core-engine/schema/system-relationships/is-user-relationship-target.js'
import { loadAuthoredGeneratedSchema } from './load-authored-generated-schema.js'

export function readRelationshipTargetKind(
  schemasDir: string,
  schemaName: string
): RelationshipTargetKind {
  if (isUserRelationshipTarget(schemaName)) {
    return 'user'
  }

  return loadAuthoredGeneratedSchema(schemasDir, schemaName).kind
}
